

export const RegenerateContentApi = Symbol('RegenerateContentApi');

export interface ApiRegenerateContentRequest {
    task_id: string;
}

export interface RegenerateContentApi {
    /**
     * 交底书 - 重新生成前调用 ！！！ 不通用
     */
    regenerateContent(params: ApiRegenerateContentRequest): Promise<void>;
}
